import { Box, makeStyles } from '@material-ui/core';
import React from 'react';

const BLUR_VALUE = '45px';
const BRIGHTNESS_VALUE = 0.9;

const useBlurStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      top: 0,
      position: 'absolute',
      display: 'block',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: '100%',
      height: '100%',
      clipPath: 'inset(0 0 0 0)',
      backgroundImage: (props: any) => `url(${props.image})`,
      WebkitFilter: `blur(${BLUR_VALUE})`,
      filter: `blur(${BLUR_VALUE})`,
      visibility: (props: any) => (props.isHidden ? 'hidden' : 'visible'),
    },
  },
});

interface BackgroundBlurBoxProps {
  imageSrc: string;
  keyToUse: string;
  isHidden?: boolean;
  shouldRenderBackgroundBlur?: boolean;
  children: React.ReactElement;
}

export const BackgroundBlurBox = (props: BackgroundBlurBoxProps) => {
  const { imageSrc, keyToUse, isHidden, shouldRenderBackgroundBlur, children } = props;

  if (!shouldRenderBackgroundBlur) {
    return children;
  }

  const classes = useBlurStyles({
    image: imageSrc,
    isHidden,
  });

  return (
    <Box key={keyToUse} className={classes.root} height={{ md: '100%' }} width={{ md: '100%' }}>
      <Box
        // Using !important to force override — without it, the style incorrectly sticks to 400px on desktop
        maxHeight={{ xs: '400px', md: '100% !important' }}
        maxWidth="100%"
        height={{ md: '100%' }}
        width={{ md: '100%' }}
        style={{ zIndex: 1 }}
      >
        {children}
      </Box>
    </Box>
  );
};
